import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function ProtectedRoute({ children }) {
    const navigate = useNavigate();
    // 1. Load the authenticated user
    const isLoading = false;
    const isAuthenticated = localStorage.getItem("user");

    // 2. If there is NO authenticated user, redirect to the /login
    useEffect(
        function () {
            if (!isAuthenticated && !isLoading) navigate("/sign-in");
        },
        [isAuthenticated, isLoading, navigate]
    );

    // 3. While loading, show a spinner
    if (isLoading) return <>در حال لودینگ</>;

    // 4. If there IS a user, render the app
    if (isAuthenticated) return children;
}

export default ProtectedRoute;
